export default __webpack_public_path__ + "static/media/projTrack4.b0ec8b2f.png";